"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hex = exports.rgb = void 0;
var assert_sidecar_1 = require("./assert-sidecar");
function rgb(r, g, b) {
    return (r << 16) + (g << 8) + b;
}
exports.rgb = rgb;
function hex(h) {
    if (h.startsWith('#')) {
        h = h.substring(1);
    }
    if (h.length === 6) {
        var r = parseInt(h.substring(0, 2), 16);
        var g = parseInt(h.substring(2, 4), 16);
        var b = parseInt(h.substring(4, 6), 16);
        return rgb(r, g, b);
    }
    assert_sidecar_1.assert.failed('invalid hex string', h);
    return 0;
}
exports.hex = hex;
